import { Divider } from '@dynatrace/strato-components/layouts';

import { RectSeriesTooltipBody } from './RectSeriesTooltipBody.js';
import { RectSeriesTooltipHeader } from './RectSeriesTooltipHeader.js';
import type {
  RectDatapointInternal,
  RectSeriesWithDatapoints,
} from '../../../types/xy-chart-internals.js';

export function RectSeriesTooltip({
  datapoint,
  series,
}: {
  datapoint: RectDatapointInternal;
  series: RectSeriesWithDatapoints;
}) {
  return (
    <>
      <RectSeriesTooltipHeader datapoint={datapoint} series={series} />
      <Divider orientation="horizontal" />
      <RectSeriesTooltipBody datapoint={datapoint} series={series} />
    </>
  );
}
